<template>
  <cTable
    style="height: calc(100vh - 200px)"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
    <template #header>
      <Tabs v-model="type" @on-click="handleTab" :name="name">
        <TabPane
          v-for="(item, idx) in tabList"
          :key="idx"
          :tab="name"
          :label="item.label"
          :name="item.value"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/b2borderStatistics";
export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.header.searchs.splice(
      0,
      0,
      {
        type: "checkbox",
        width: 50,
        align: "center"
      },
      ...this.headers
    );
  },
  methods: {
    handleTab(tab) {
      this.type = tab;
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
    }
  },
  data() {
    return {
      type: "index",
      tabList: [
        {
          label: this.$tz("全部,统计"),
          value: "index"
        },
        {
          label: this.$tz("国家,统计"),
          value: "country"
        }
      ],
      methods: {
        ...apis,
        list: p => {
          p.type = this.type;
          return apis[this.name](p);
        },
        beforeHandleList: ({ data }) => {
          return data;
        }
      },
      config: {
        tabHeight: -30,
        slot: "div",
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("详情,导出"),
              type: "detail",
              fnName: "detail",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            },
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$tz("服务项目"),
          key: "service",
          minWidth: 130
        },
        ...["SA", "AE", "BH", "QA", "KW", "OM"].map(t => {
          return {
            name: t,
            key: t.toLocaleLowerCase() + "_num",
            minWidth: 130,
            show: () => this.type == "country"
          };
        }),
        {
          name: () => this.$tz("其他"),
          key: "ot_num",
          minWidth: 110
        },
        {
          name: () => this.$tz("票数"),
          key: "num",
          minWidth: 130
        },
        {
          name: () => this.$tz("票数,占比"),
          key: "num_rate",
          minWidth: 130
        },
        {
          name: () => this.$tz("重量"),
          key: "weight",
          minWidth: 130
        },
        {
          name: () => this.$tz("重量,占比"),
          key: "weight_rate",
          minWidth: 130
        },
        {
          name: () => this.$tz("体积"),
          key: "volume",
          minWidth: 130
        },
        {
          name: () => this.$tz("体积,占比"),
          key: "volume_rate",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
